import * as React from 'react';
import { cn } from '@workspace/lib';
import { cardVariants } from '@workspace/ui/common/Card/card.variants';

const { base, media, header, title, description, content, footer, action } = cardVariants();

export function Card({ className, ...props }: React.ComponentProps<'article'>) {
  return <article data-slot="card" className={cn(base(), className)} {...props} />;
}

export function CardMedia({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="card-media" className={cn(media(), className)} {...props} />;
}

export function CardHeader({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="card-header" className={cn(header(), className)} {...props} />;
}

export function CardTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="card-title" className={cn(title(), className)} {...props} />;
}

export function CardDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="card-description" className={cn(description(), className)} {...props} />;
}

export function CardContent({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="card-content" className={cn(content(), className)} {...props} />;
}

export function CardFooter({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="card-footer" className={cn(footer(), className)} {...props} />;
}

export function CardAction({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="card-action" className={cn(action(), className)} {...props} />;
}
